export default {
  headlineText: 'Confirm your address',
  bodyTitle:
    'Check the address below and confirm it’s where you’d like to receive your new Varo Visa Card.',
  homeAddress: 'Home address',
  mailingAddress: 'Mailing address',
  confirmAddressButton: 'Confirm address',
  editAddressButton: 'Edit address',
  faqButtonText: 'FAQ',
  successMessage: 'Your address has been confirmed.',
  successScreen: {
    title: 'Address updated',
    eyebrowText: 'Success',
    body: 'We’ll let you know when your card is on the way!',
    message: 'We’ll let you know when your card is on the way!',
    button: 'Done',
  },
  error: {
    button: 'Try again',
    closeButton: 'Close',
    title: 'Something’s not right.',
    message: 'We’re working on it.',
  },
};
